import isPropValid from '@emotion/is-prop-valid'

// reduce silly unrecognized DOM attribute errors
// on styled components
// this wasn't always working for me, sometimes a manual list is more reliable:
// grep the code for 'shouldForwardProp'
export const withProps = (include: string[], exclude: string[]) => {
	return {
		shouldForwardProp: (prop: string): boolean => {
			const willInclude = (include.includes(prop) || isPropValid(prop)) && !exclude.includes(prop)
			// console.debug(`${prop} => ${willInclude}`)
			return willInclude
		}
	}
}

// the golden ratio
export const φ = (1 + Math.sqrt(5)) / 2
